import ToastModule from '@modules/ToastModule';

export type ClassificationWaitStatus = 'NotReady' | 'NotEnded';

const classificationWaitBodies: Record<ClassificationWaitStatus, string> = {
  NotReady:
    'Call classification is still processing, please wait and try again in a few minutes.',
  NotEnded:
    'Call cannot be closed until it has ended, please wait and try again in a few minutes.',
};

/** The warning toast shared by completion and the Close pre-check. */
export function showClassificationWaitToast(status: ClassificationWaitStatus) {
  ToastModule.showToast({
    title: 'Please Wait',
    status: 'warning',
    toastBody: classificationWaitBodies[status],
  });
}
